var HttpResponse = (function () {
    function HttpResponse(status, statusCode, contentLength, headers, cookies, body) {
        this.status = status;
        this.statusCode = statusCode;
        this.contentLength = contentLength;
        this.headers = headers;
        this.cookies = cookies;
        this.body = body;
    }
    return HttpResponse;
}());
export default HttpResponse;
//# sourceMappingURL=HttpResponse.js.map